import src from "IMAGE";
export default { src, width: 1025, height: 1025, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAALElEQVR42r2PMQoAAAgCtf8/uiCIkKgtweluUCDDqEkJgZqSJtilD+Ecud50GYAAMTcyFwIAAAAASUVORK5CYII="};
